inputs-complex-select-phase
  div(class="form-group row { error: opts.errors }")
    .col-12
      span.radio-wrap.phase-wrap(each="{ item, index in this.opts.items }" style="border-bottom:5px solid {item.colorcode}")
        input(if="{ item.value == parent.opts.value }" data-color="{ item.colorcode }" checked="checked" id="{this.tagScope}_{index}" type="radio" value="{ item.value }" name="{ parent.opts.name }" onChange="{ parent.onChange }")
        input(if="{ item.value != parent.opts.value }" data-color="{ item.colorcode }" id="{this.tagScope}_{index}" type="radio" value="{ item.value }" name="{ parent.opts.name }" onChange="{ parent.onChange }")
        label(for="{this.tagScope}_{index}") { item.label }
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.complex.select-phase');
  style(scoped).
    .radio-wrap {
      display: inline-block;
      margin-right: .5em;
      margin-top: .5em;
    }
    .phase-wrap {
      margin-right: 1px;
      border-radius: 2px;
      padding: 7px 10px 0px 10px;
    }
    .phase-wrap label {
      margin-bottom: 0;
    }
